import React from 'react'
import './../css/GeneralPages.css'
import PageTitle from '../includes/PageTitle'
import Footer from '../includes/Footer'

export default function Contact() {
  return (
    <>
        <PageTitle title="Contact Us - ALMOSTINVISIBLE" />
        <div className="gen-intro px-4">
          <h1 className="unbounded text-fluid">
            Contact Us
          </h1>
        </div>

        <div className="gen-content">
          
           <div className="container">
            
            
            
             
                    <h3 className='unbounded'>
                        Email Address
                    </h3>
                    <a href="mailto:info@vlmstnvsbl.com" className='black-text' style={{color: 'black'}}>
                        info@vlmstnvsbl.com
                    </a>
                    <hr />
                    <h3 className='unbounded' >
                        Phone Number 
                    </h3>
                    <a href="tel:+2348920020220" style={{color: 'black'}}>
                        +2346738839292
                    </a>
          </div>
        </div>
    <Footer />
    </>
  )
}
